// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"style_dropzone__2X8AO"};